import { render, staticRenderFns } from "./channel_management.vue?vue&type=template&id=475e97b9&scoped=true&"
import script from "./channel_management.vue?vue&type=script&lang=js&"
export * from "./channel_management.vue?vue&type=script&lang=js&"
import style0 from "./channel_management.vue?vue&type=style&index=0&id=475e97b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e97b9",
  null
  
)

export default component.exports